var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "data-name": "Layer 1",
        width: "200",
        height: "170",
        viewBox: "0 0 200 170",
      },
    },
    [
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "cancel-plan-gradient",
                x1: "100",
                y1: "0",
                x2: "100",
                y2: "170",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: {
                  offset: "0",
                  "stop-color": "#f86d70",
                  "stop-opacity": "0.2",
                },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: {
                  offset: "0.54",
                  "stop-color": "#f86d70",
                  "stop-opacity": "0.1",
                },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: {
                  offset: "1",
                  "stop-color": "#f86d70",
                  "stop-opacity": "0.05",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("circle", {
        attrs: {
          cx: "100",
          cy: "85",
          r: "65",
          fill: "url(#cancel-plan-gradient)",
        },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: {
          cx: "100",
          cy: "60",
          r: "32",
          fill: "#f86d70",
          opacity: "0.15",
        },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: {
          cx: "100",
          cy: "60",
          r: "28",
          fill: "none",
          stroke: "#f86d70",
          "stroke-width": "2.5",
          "stroke-opacity": "0.4",
        },
      }),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            stroke: "#f86d70",
            "stroke-width": "4",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        },
        [
          _c("line", { attrs: { x1: "85", y1: "45", x2: "115", y2: "75" } }),
          _vm._v(" "),
          _c("line", { attrs: { x1: "115", y1: "45", x2: "85", y2: "75" } }),
        ]
      ),
      _vm._v(" "),
      _c("g", { attrs: { transform: "translate(60, 105)" } }, [
        _c("rect", {
          attrs: {
            x: "0",
            y: "0",
            width: "80",
            height: "50",
            rx: "4",
            fill: "#3f3d56",
            opacity: "0.08",
          },
        }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            x: "4",
            y: "4",
            width: "72",
            height: "42",
            rx: "2",
            fill: "#fff",
            opacity: "0.95",
          },
        }),
        _vm._v(" "),
        _c("line", {
          attrs: {
            x1: "14",
            y1: "14",
            x2: "66",
            y2: "14",
            stroke: "#3f3d56",
            "stroke-width": "1.5",
            opacity: "0.25",
          },
        }),
        _vm._v(" "),
        _c("line", {
          attrs: {
            x1: "14",
            y1: "22",
            x2: "58",
            y2: "22",
            stroke: "#3f3d56",
            "stroke-width": "1.5",
            opacity: "0.2",
          },
        }),
        _vm._v(" "),
        _c("line", {
          attrs: {
            x1: "14",
            y1: "30",
            x2: "52",
            y2: "30",
            stroke: "#3f3d56",
            "stroke-width": "1.5",
            opacity: "0.2",
          },
        }),
        _vm._v(" "),
        _c("circle", {
          attrs: {
            cx: "70",
            cy: "12",
            r: "6",
            fill: "#f86d70",
            opacity: "0.2",
          },
        }),
        _vm._v(" "),
        _c("line", {
          attrs: {
            x1: "67",
            y1: "9",
            x2: "73",
            y2: "15",
            stroke: "#f86d70",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
          },
        }),
        _vm._v(" "),
        _c("line", {
          attrs: {
            x1: "73",
            y1: "9",
            x2: "67",
            y2: "15",
            stroke: "#f86d70",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
          },
        }),
      ]),
      _vm._v(" "),
      _c("circle", {
        attrs: {
          cx: "35",
          cy: "35",
          r: "2.5",
          fill: "#f86d70",
          opacity: "0.3",
        },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: {
          cx: "165",
          cy: "35",
          r: "2.5",
          fill: "#f86d70",
          opacity: "0.3",
        },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: {
          cx: "35",
          cy: "135",
          r: "2.5",
          fill: "#f86d70",
          opacity: "0.3",
        },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: {
          cx: "165",
          cy: "135",
          r: "2.5",
          fill: "#f86d70",
          opacity: "0.3",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }